import React, { useMemo } from "react";
import { ThemeProvider, useTheme } from "@material-ui/core/styles";
import { createCrmTheme } from "../CrmRelationship/theme";

export default function ContactsTheme({ children }) {
  const outerTheme = useTheme();
  const theme = useMemo(() => {
    const base = createCrmTheme(outerTheme);
    const dark = base.palette.type === "dark";
    const foreground = dark ? "#FFFFFF" : base.crm.text;
    return {
      ...base,
      ticketDark: dark,
      palette: {
        ...base.palette,
        text: { ...base.palette.text, primary: foreground },
        action: { ...base.palette.action, active: foreground }
      },
      overrides: {
        ...base.overrides,
        MuiIconButton: { root: { ...base.overrides.MuiIconButton.root, color: foreground } },
        MuiSelect: { icon: { color: foreground } },
        MuiInputLabel: { root: { color: foreground } }
      }
    };
  }, [outerTheme]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
